import { T } from "../themes";

export default function Btn({ onClick, disabled, children, color, outline, small, danger, full=true, style:xs={} }) {
  const bg  = disabled?T.surface:danger?T.red:outline?"transparent":(color||T.accent);
  const col = disabled?T.textDim:danger?"#fff":outline?(color||T.accent):"#fff";
  const bdr = outline?`1.5px solid ${color||T.accent}`:danger?`1.5px solid ${T.red}`:"none";
  const highlightShadow = disabled?"none":`${T.shadow}, inset 0 1px 0 rgba(255,255,255,0.15)`;
  return (
    <button onClick={onClick} disabled={disabled}
      style={{
        background:bg,color:col,border:bdr,
        boxShadow:highlightShadow,
        borderRadius:12,
        padding:small?"9px 20px":"15px 22px",
        fontSize:small?12:14,fontWeight:700,fontFamily:T.fontSans,
        letterSpacing:"0.01em",cursor:disabled?"default":"pointer",
        width:full?"100%":"auto",display:"flex",alignItems:"center",
        justifyContent:"center",gap:7,
        transition:"opacity 0.15s,transform 0.1s",
        opacity:disabled?0.5:1,
        ...xs,
      }}>
      {children}
    </button>
  );
}
